export default "__VITE_ASSET__DojC_4Zd__"